<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>积分订单详情</span>
        <el-button @click="backToList">返回列表</el-button>
      </div>

      <el-descriptions :column="2" border v-loading="loading">
        <el-descriptions-item label="订单号">{{ detail.orderNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ statusText(detail.orderStatus) }}</el-descriptions-item>
        <el-descriptions-item label="消耗积分">{{ detail.pointsAmount || 0 }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDateTime(detail.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="发货时间">{{ formatDateTime(detail.deliveryTime) }}</el-descriptions-item>
        <el-descriptions-item label="收货时间">{{ formatDateTime(detail.receiveTime) }}</el-descriptions-item>
        <el-descriptions-item label="收货人">{{ detail.receiverName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detail.receiverMobile || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收货地址" :span="2">{{ fullAddress }}</el-descriptions-item>
        <el-descriptions-item v-if="detail.expressCompany" label="物流信息" :span="2">
          {{ detail.expressCompany }} {{ detail.expressNo }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <el-card shadow="never" style="margin-top: 20px">
      <div slot="header">商品明细</div>
      <el-table :data="detail.items || []" border v-loading="loading">
        <el-table-column prop="productName" label="商品名称" />
        <el-table-column prop="pointsCost" label="单件积分" width="120" />
        <el-table-column prop="quantity" label="数量" width="100" />
        <el-table-column prop="totalPoints" label="总积分" width="120" />
      </el-table>
    </el-card>

    <el-card v-if="Number(detail.orderStatus) === 0" shadow="never" style="margin-top: 20px">
      <div slot="header">订单发货</div>
      <el-form label-width="100px">
        <el-form-item label="快递公司">
          <el-input v-model.trim="delivery.expressCompany" />
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model.trim="delivery.expressNo" />
        </el-form-item>
      </el-form>
      <el-button type="primary" :loading="submitting" @click="submitDelivery">确认发货</el-button>
    </el-card>
  </div>
</template>

<script>
import { deliveryPointOrder, getPointOrderDetail } from '../../api/admin'
import { formatDateTime } from '../../utils/format'

export default {
  props: {
    orderNo: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      detail: { items: [] },
      delivery: {
        expressCompany: '',
        expressNo: ''
      }
    }
  },
  computed: {
    fullAddress() {
      return [this.detail.receiverProvince, this.detail.receiverCity, this.detail.receiverDistrict, this.detail.receiverAddress]
        .filter(Boolean)
        .join('')
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    formatDateTime,
    statusText(status) {
      const map = { 0: '待发货', 1: '待收货', 2: '已完成', 3: '已取消' }
      return map[status] || '未知状态'
    },
    async loadDetail() {
      this.loading = true
      try {
        this.detail = await getPointOrderDetail(this.orderNo)
      } finally {
        this.loading = false
      }
    },
    async submitDelivery() {
      if (!this.delivery.expressCompany || !this.delivery.expressNo) {
        this.$message.error('请填写快递公司和物流单号')
        return
      }
      this.submitting = true
      try {
        await deliveryPointOrder({
          orderNo: this.orderNo,
          expressCompany: this.delivery.expressCompany,
          expressNo: this.delivery.expressNo
        })
        this.$message.success('发货成功')
        this.backToList()
      } finally {
        this.submitting = false
      }
    },
    backToList() {
      this.$router.push({
        path: '/point-mall/orders',
        query: this.$route.query.q ? { q: this.$route.query.q } : {}
      })
    }
  }
}
</script>

<style scoped>
.card-header { display: flex; justify-content: space-between; align-items: center; }
</style>
